import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LOGO_IMG from "../img/logo.png";
import "../styles/header.css";
import { ROUTES, NAVIGATION_OPTIONS } from '../config/routes';

export default function Header() {
    const auth = useAuth();
    const navigate = useNavigate();
    const location = useLocation(); 

   // AuthContextから値を取得
    const logout = auth?.logout;
    const isAuthenticated = auth?.isAuthenticated?.() || false;
    const getUserDisplayName = auth?.getUserDisplayName;
    const profileLoading = auth?.profileLoading || false;

    /**
     * ログイン情報を非表示にするパスの定義
     * クレジットカード入力画面と会員登録完了画面では非表示
     */
    const hideAuthPaths = [
        ROUTES.CREDIT_CARD_INPUT,
        ROUTES.REGISTRATION_COMPLETE
    ];

    /**
     * 現在のパスでログイン情報を表示するかどうかを判定
     * @returns {boolean} 表示する場合はtrue、非表示の場合はfalse
     */
    const shouldShowAuthInfo = () => {
        const currentPath = location.pathname;
        return !hideAuthPaths.includes(currentPath);
    };

    /**
     * ログアウト処理
     */
    const handleLogout = async () => {
        try {
            if (logout) {
            await logout();
            navigate(ROUTES.LOGIN, NAVIGATION_OPTIONS.REPLACE);
            }
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    /**
     * 表示名を取得する関数
     * 優先順位: displayName > userEmail > 'ゲスト'
     */
    const getDisplayName = () => {
        if (getUserDisplayName) {
            return getUserDisplayName();
        }
        return 'ゲスト';
    };

    return (
        <header className="main-header">
            {/* 左側: 空のスペース（バランスを取るため） */}
            <div className="header-left-space"></div>

            {/* 中央: ロゴ */}
            <div className="logo-container">
                <Link to={ROUTES.ROOT}>
                    <img src={LOGO_IMG} className="logo-image" alt="logo" />
                </Link>
            </div>

            {/* 右側: ユーザー情報とログアウトボタン（条件付き表示） */}
            <div className="header-right-container">
                {/* 
                  ログイン情報表示の条件:
                  1. 現在のパスが非表示対象でない
                  2. かつユーザーが認証済み
                */}
                {shouldShowAuthInfo() && isAuthenticated && (
                    <div className="user-section">
                        <div className="user-info">
                            <span className="welcome-text">
                                ようこそ、
                            </span>
                        <span className="user-name" translate="no">
                            {profileLoading ? 'Loading...' : `${getDisplayName()}さん`}
                        </span>
                    </div>
                    
                    <button 
                        className="logout-button"
                        onClick={handleLogout}
                    >
                        ログアウト
                    </button>
                </div>
            )}
        </div>
        </header>
    );
}